import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/theme.css";
import "./styles/landing.css";

createRoot(document.getElementById("root")).render(<App />);
